import { Component, OnInit } from '@angular/core';
import { Toast } from 'app/shared/toast/toast';
import { MicrosoftAuth } from '../onedrive/onedrive.type';

@Component({
   selector: 'app-oauth-callback',
   template: '',
})
export class CallbackDropboxComponent implements OnInit {
    errorMessage: any;

    constructor(private toast: Toast) {}

    ngOnInit() {
        const url = window.location.href.match(/\=([\S\s]*?)\&/);
        this.onAuthCallback();
        window.opener.postMessage({ message: 'deliverResult', result: true }, url);
        
        let link = window.opener.document.getElementById('link_dropbox');
        if (link) {
            link.click();
        }
        window.close();
    }

    onAuthCallback() {
        const authInfo = this.getAuthInfoFromUrl();
        if (!authInfo) {
            return;
        }

        const access_token = authInfo['access_token'];
        
        if (access_token) {
                localStorage.setItem('dropbox_callback', 'true');
        }
    }

    getAuthInfoFromUrl() {
        if (window.location.hash) {
            const authResponse = window.location.hash.substring(1);
            const authInfo: MicrosoftAuth = JSON.parse(
                '{' + authResponse.replace(/([^=]+)=([^&]+)&?/g, '"$1":"$2",').slice(0, -1) + '}',
                function(key, value) { return key === '' ? value : decodeURIComponent(value); });
            
            const access_token = authInfo['access_token'];
            if(access_token) {
                window.localStorage.setItem('access_token_dropbox', access_token);
            }

            return authInfo;
        } else {
            this.toast.error('failed to receive auth token');
        }
    }

}
